var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16699 5.83301V12.5H15.834V5.83301H4.16699Z",
    fill: "#494b74"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16709 15.833V13.333C9.16709 13.112 9.25491 12.8999 9.41122 12.7436C9.56753 12.5873 9.77954 12.4995 10.0006 12.4995C10.2217 12.4995 10.4337 12.5873 10.59 12.7436C10.7463 12.8999 10.8341 13.112 10.8341 13.333V15.833H12.0841C12.1405 15.8302 12.1969 15.839 12.2498 15.8587C12.3028 15.8783 12.3512 15.9086 12.3921 15.9475C12.433 15.9865 12.4655 16.0333 12.4878 16.0852C12.51 16.1371 12.5215 16.193 12.5215 16.2495C12.5215 16.306 12.51 16.3619 12.4878 16.4138C12.4655 16.4657 12.433 16.5126 12.3921 16.5515C12.3512 16.5905 12.3028 16.6207 12.2498 16.6404C12.1969 16.6601 12.1405 16.6688 12.0841 16.666H7.91709C7.81016 16.6608 7.70934 16.6146 7.63551 16.5371C7.56169 16.4595 7.52051 16.3566 7.52051 16.2495C7.52051 16.1425 7.56169 16.0395 7.63551 15.962C7.70934 15.8844 7.81016 15.8383 7.91709 15.833H9.16709Z",
    fill: "#494b74"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.167 5.83397V12.501H15.833V5.83397H4.167ZM4.375 4.16697H15.625C16.0943 4.14098 16.5548 4.30167 16.9061 4.61398C17.2574 4.92628 17.4709 5.36485 17.5 5.83397V12.501C17.4706 12.9699 17.257 13.4082 16.9058 13.7203C16.5545 14.0324 16.0941 14.193 15.625 14.167H4.375C3.90569 14.193 3.44515 14.0323 3.09388 13.72C2.74261 13.4077 2.52912 12.9691 2.5 12.5V5.83397C2.52912 5.36485 2.74261 4.92628 3.09388 4.61398C3.44515 4.30167 3.90569 4.14098 4.375 4.16697Z",
    fill: "#494b74"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.3c205bc596ea02837c89610321bbb4ea.svg";
export { ForwardRef as ReactComponent };